import { Button, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/lab/Alert";
import { type SyntheticEvent, useState } from "react";

import { ButtonWithLoading, ErrorModal, MesfModal } from "@dexteel/mesf-core";
import { useFormsContext } from "../../../context/FormsContext";
import { deleteOption } from "../../../repositories/FormsRepository";

type Props = {
	show: boolean;
	onHide: (onHide: boolean) => void;
	setShouldUpdateWhenExit: (onHide: boolean) => void;
};

export const DeleteOptionDialog = ({
	show,
	onHide,
	setShouldUpdateWhenExit,
}: Props) => {
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [optionRemovedSuccess, setOptionRemovedSuccess] =
		useState<boolean>(false);
	const [error, setError] = useState<string>("");
	const {
		state: {
			optionSelectedInTable: { OptionId, OptionText },
		},
	} = useFormsContext();

	const handleCancel = () => {
		setIsSubmitLoading(false);
		onHide(false);
	};

	const handleClose = (
		event: Event | React.SyntheticEvent,
		reason?: string,
	) => {
		if (reason === "clickaway") {
			return;
		}
		setOptionRemovedSuccess(false);
	};

	const handleRemoveOption = async () => {
		setIsSubmitLoading(true);
		const res = await deleteOption(OptionId as number);
		if (res.ok) {
			setOptionRemovedSuccess(true);
			setIsSubmitLoading(false);
			onHide(true);
			setShouldUpdateWhenExit(true);
		} else {
			setError(res.message);
			setIsSubmitLoading(false);
		}
	};

	return (
		<>
			<MesfModal
				title="DELETE OPTION"
				open={show}
				handleClose={() => handleCancel()}
				maxWidth="sm"
				id="form-delete-option-modal"
			>
				<MesfModal.Content dividers>
					<Typography>
						Delete <b>{OptionText}</b>? Once deleted it cannot be recovered.
					</Typography>
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "20px 16px 16px" }}>
					<Grid2 container spacing={2} justifyContent="flex-end" width="100%">
						<Grid2 size={{ md: 3, xs: 12 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={() => onHide(false)}
							>
								Cancel
							</Button>
						</Grid2>
						<Grid2 size={{ md: 3, xs: 12 }}>
							<ButtonWithLoading
								fullWidth
								isLoading={isSubmitLoading}
								variant="contained"
								color="secondary"
								onClick={handleRemoveOption}
							>
								Delete
							</ButtonWithLoading>
						</Grid2>
					</Grid2>
				</MesfModal.Actions>
			</MesfModal>
			<Snackbar
				open={optionRemovedSuccess}
				autoHideDuration={2500}
				onClose={handleClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
			>
				<Alert severity="info" onClose={handleClose}>
					Option removed succesfully
				</Alert>
			</Snackbar>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
